import React, { useRef, useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from '@mui/material';
import './draggable.css'
const FixedBox = {
    position: 'absolute',
    top: 0, bottom: 0,
    left: 0, right: 0,
    margin: 'auto',
    zIndex: 1999,
    userSelect: "none",
}
const FlexBox = {
    cursor: 'pointer',
    display: 'flex',
    gap: 2, alignItems: 'center', justifyContent: 'center', '&hover': { opacity: 0.6 }
}
const warppBox = { position: 'relative', m: 0, width: 140, height: 140 }

const fixWH = { width: 40, height: 40 }
export default function NaviBox({ icons,
    gap = 1, onChange = (status) => { },
    pan_tilt_only = false,
    zoom_only = false, zoom = 1
}) {

    if (zoom_only) return (
        <>
            <Box className="icon-filled-black" sx={{ ...FlexBox, gap: gap, justifyContent: 'space-between', gap: 0 }}>
                <Box sx={fixWH} onClick={() => onChange("zoom-in")}>{icons.zoom_in}</Box>
                <Box sx={{ ...FlexBox, justifyContent: 'space-between', width: 1 }}>
                    <Box className="zoom-line" sx={{ height: 1, width: 1, borderBottom: '1px solid white' }}></Box>
                    <Box className="input-label" sx={{ color: 'white', fontSize: 16 }}>{zoom}x</Box>
                    <Box className="zoom-line" sx={{ height: 1, width: 1, borderBottom: '1px solid white' }}></Box>
                </Box>
                <Box sx={fixWH} onClick={() => onChange("zoom-out")}>{icons.zoom_out}</Box>
            </Box>
        </>
    )
    return <Box
        className="controll-containter icon-filled-black"
        sx={{ ...warppBox, height: pan_tilt_only ? 'auto' : 40 }}>
        <Box sx={{ bottom: 0, position: 'absolute', zIndex: 1999, width: 1 }}>
            <Box sx={{ ...FlexBox, gap: gap }} className={pan_tilt_only ? "" : "controlls"}>
                {!pan_tilt_only && <Box sx={fixWH} ></Box>}
                <Box sx={fixWH} onClick={() => onChange("up")}>{icons.move_up}</Box>
                {!pan_tilt_only && <Box sx={fixWH} onClick={() => onChange("zoom-in")}>{icons.zoom_in}</Box>}
            </Box>
            <Box sx={{ ...FlexBox, gap: gap, my: gap }}>
                <Box sx={fixWH} onClick={() => onChange("left")} className={pan_tilt_only ? "" : "controlls"}>{icons.prev}</Box>
                <Box className="icon-filled-path" sx={fixWH} onClick={() => onChange("reset")}>{icons.center}</Box>
                <Box sx={fixWH} onClick={() => onChange("right")} className={pan_tilt_only ? "" : "controlls"}>{icons.next}</Box>
            </Box>
            <Box sx={{ ...FlexBox, gap: gap }} className={pan_tilt_only ? "" : "controlls"}>
                {!pan_tilt_only && <Box sx={fixWH}></Box>}
                <Box sx={fixWH} onClick={() => onChange("down")}>{icons.move_down}</Box>
                {!pan_tilt_only && <Box sx={fixWH} onClick={() => onChange("zoom-out")}>{icons.zoom_out}</Box>}
            </Box>

        </Box>
    </Box>
}